import React, { useState, useRef } from 'react'
import { Editor } from '@tinymce/tinymce-react'
import PropTypes from 'prop-types'
import { TeacherAPIRoutes } from '../../api/APIRoutes'
import { protectedPostData } from '../../api/Interface'
import loadingWhite from '../../assets/images/loading_white.svg'
import Loader from './loaders/Loader'
import { openNotificationWithIcon } from '../../Helper'

export default function TinyMc({ onChange, value, lessonpagecode }) {
  const [isLoading, setIsLoading] = useState(true)
  const editorRef = useRef(null)
  const ref = []

  const handleKeyDown = async (e) => {
    if (e.keyCode === 8 || e.keyCode === 46) {
      const node = editorRef.current.selection.getNode()
      if (node.nodeName === 'IMG') {
        const removedImage = ref.current.find((image) => image.url === node.src)
        const data = new FormData()
        data.append('file_id', removedImage.id)
        data.append('lesson_page_code', lessonpagecode)
        let response = await protectedPostData(
          TeacherAPIRoutes.ClassroomLessonPagesImagesRemove,
          data,
        )
        if (response) {
          openNotificationWithIcon('success', 'موفق', 'با موفقیت حذف شد')
        }
      }
    }
  }

  let configs = {
    height: 500,
    menubar: false,
    images_upload_handler: async (blobInfo, success, failure) => {
      const data = new FormData()
      var reader = new FileReader()
      data.append('file', blobInfo.blob())
      data.append('lesson_page_code', lessonpagecode)
      blobInfo.blob().size >= 500000
        ? failure('حجم تصویر بیش از500KB است', { remove: true })
        : protectedPostData(
            TeacherAPIRoutes.ClassroomLessonPagesImagesUpload,
            data,
          )
            .then((response) => {
              success(response.data.url, { id: response.data.id })
              ref.current.push({ id: response.data.id, url: response.data.url })
            })
            .catch((err) => console.error(err))
      reader.readAsDataURL(blobInfo.blob())
    },
    setup: function (editor) {
      editor.on('keydown', function (e) {
        handleKeyDown(e)
      })
    },
    plugins: [
      'advlist',
      'autolink',
      'lists',
      'link',
      'image',
      'charmap',
      'print',
      'anchor',
      'searchreplace',
      'visualblocks',
      'code',
      'fullscreen',
      'insertdatetime',
      'media',
      'table',
      'preview',
      'help',
      'wordcount',
    ],
    external_plugins: {
      tiny_mce_wiris: 'https://www.wiris.net/demo/plugins/tiny_mce/plugin.js',
    },
    toolbar:
      'undo redo | styleselect | fontsizeselect | blocks ' +
      'bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify outdent indent|' +
      ' bullist numlist | ' +
      'image link table |' +
      'tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry',
    content_style:
      'body { font-family:IRANSans,Shabnam,Dana Reg,Dana Web,Helvetica,Arial,sans-serif; font-size:14px; text-align: right } img {max-width: 100%;}',
    branding: false,
    media_alt_source: false,
    media_poster: false,
    draggable_modal: true,
    htmlAllowedTags: ['.*'],
    htmlAllowedAttrs: ['.*'],
    extended_valid_elements: '*[.*]',
    font_size_formats:
      '8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt',
    font_formats:
      'IRANSans; Shabnam; Dana Reg; Dana Web; Helvetica; Arial; sans-serif',
  }

  const handleEditorChange = (e) => {
    if (onChange) {
      onChange(e.target.getContent())
    }
  }

  return (
    <>
      {isLoading ? (
        <>
          <Loader />
          <br />
          <br />
        </>
      ) : null}
      <Editor
        onBeforeRenderUI={() => setIsLoading(true)}
        onPreProcess={(e) => setIsLoading(true)}
        onPostProcess={(e) => setIsLoading(false)}
        onLoadContent={() => setIsLoading(true)}
        apiKey="your-api-key"
        initialValue={value}
        init={configs}
        tinymceScriptSrc="/vendor/tinymce/scripts/tinymce.min.js"
        onBlur={(e) => {
          handleEditorChange(e)
        }}
        onInit={(evt, editor) => (editorRef.current = editor)}
      />
    </>
  )
}

TinyMc.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
}
